import './details/archive';
import './details/delete';
import './details/restore';

import './list/export';
import './list/view';

import './sms-template-list/create-template'
import './sms-template-list/edit-template'



// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/index.js